module.exports = __webpack_public_path__ + "static/media/favicon.8b7b79ad.png";